import { cx } from "@linaria/core";
import { Swatch } from "timvir/blocks";
import { useBlock } from "timvir/core";
import * as React from "react";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  /**
   * Array of CSS Color values.
   */
  values: Array<string | {
    value: string;
    contrastValue?: string;
    name?: string;
    ancestry?: string;
  }>;
}
function ColorBar(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const block = useBlock(props);
  const {
    values,
    className,
    ...rest
  } = block.props;
  const [selected, setSelected] = React.useState<undefined | Props["values"][number]>(undefined);
  return <Root ref={ref} className={cx(className, classes.root, selected && tweaks.selected)} {...rest}>
      <div className={classes.bar} style={{
      opacity: selected ? 0 : 1
    }}>
        {values.map((value, i) => <div key={i} className={classes.value}>
            <div style={{
          background: typeof value === "string" ? value : value.value
        }} onClick={() => {
          setSelected(value);
        }} />
          </div>)}
      </div>

      <div className={classes.overlay}>
        <Swatch {...typeof selected === "string" ? {
        value: selected
      } : {
        value: selected?.value ?? ""
      }} onMouseLeave={() => {
        setSelected(undefined);
      }} />
      </div>
    </Root>;
}
export default React.forwardRef(ColorBar);
const tweaks = {
  selected: "s4sqb81"
};
const classes = {
  root: "r1f19pie",
  bar: "b15hqsfj",
  value: "v1uw85xw",
  overlay: "o1823law"
};

require("./ColorBar.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./ColorBar.tsx");